const btn = document.getElementById("btnToTop");

window.onscroll = function() {scrollFunction()};

function scrollFunction() {
    if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
        btn.classList.remove("inactive");
    } else {
        // btn.style.transform = "translateX(200px)";
        btn.classList.add("inactive");
    }
}

function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

btn.addEventListener("click", () => {
    topFunction()
})